/**
 * Demo persona store (CT-4203) — MOCK stand-in for RBAC.
 *
 * A module-level singleton (not React context) so every `useIntegrationsPermissions`
 * consumer across the domain — the Integrations home, provider/instance layouts,
 * and the Requests surface — reads the same persona WITHOUT needing a Provider
 * wrapping them (which would break existing render tests).
 *
 * In V1 there is no role (see useIntegrationsPermissions' TODO(CT-3900/ARP-804)),
 * so a demo toggle flips this to preview the end-user experience. When real RBAC
 * lands, the persona comes from the token/permissions endpoint and this store —
 * plus its toggle — is deleted; only useIntegrationsPermissions changes.
 *
 * @typedef {'admin' | 'user'} Persona
 */

/** @type {Persona} */
let persona = 'admin';
const listeners = new Set();

export const getPersona = () => persona;

export const setPersona = (next) => {
  if (next !== 'admin' && next !== 'user') return;
  if (next === persona) return;
  persona = next;
  listeners.forEach((notify) => notify());
};

export const subscribePersona = (notify) => {
  listeners.add(notify);
  return () => listeners.delete(notify);
};

/** Test-only: reset the demo persona back to the default. */
export const __resetPersonaForTests = () => {
  persona = 'admin';
  listeners.forEach((notify) => notify());
};
